import React, { useState, useEffect } from 'react'
import './LoadingIndicator.css'

const LoadingIndicator = () => {
  const [loadingText, setLoadingText] = useState('Initializing AI models...')
  const [progress, setProgress] = useState(0)

  useEffect(() => {
    const loadingSteps = [
      { text: 'Loading face detection model...', progress: 20 },
      { text: 'Loading facial landmark model...', progress: 40 },
      { text: 'Loading emotion recognition model...', progress: 60 },
      { text: 'Initializing TensorFlow.js...', progress: 80 },
      { text: 'Preparing emotion detection...', progress: 95 },
      { text: 'Ready to explore emotions...', progress: 100 }
    ]

    let currentStep = 0
    const interval = setInterval(() => {
      if (currentStep < loadingSteps.length) {
        setLoadingText(loadingSteps[currentStep].text)
        setProgress(loadingSteps[currentStep].progress)
        currentStep++
      } else {
        clearInterval(interval)
      }
    }, 800)

    return () => clearInterval(interval)
  }, [])

  return (
    <div className="loading-container">
      <div className="loading-content">
        <div className="loading-logo">
          <div className="logo-circle">
            <span className="logo-text">AI</span>
          </div>
        </div>
        
        <h2 className="loading-title">AI Face Emotion Detector</h2>
        <p className="loading-subtitle">Powered by Sutralink</p>
        
        <div className="loading-progress">
          <div className="progress-bar">
            <div 
              className="progress-fill"
              style={{ width: `${progress}%` }}
            ></div>
          </div>
          <span className="progress-text">{progress}%</span>
        </div>
        
        <p className="loading-message">{loadingText}</p>
        
        <div className="loading-features">
          <div className="feature-item">
            <span className="feature-icon">🔒</span>
            <span className="feature-text">100% Private Processing</span>
          </div>
          <div className="feature-item">
            <span className="feature-icon">⚡</span>
            <span className="feature-text">Real-time Detection</span>
          </div>
          <div className="feature-item">
            <span className="feature-icon">🎯</span>
            <span className="feature-text">7 Emotion Categories</span>
          </div>
        </div>
      </div>
    </div>
  )
}

export default LoadingIndicator 